export const TENURE_RANGES = {
  6: '0 - 6',
  12: '7 - 12',
  24: '13 - 24',
  25: '25+'
};
